
TS.ns('WL');

WL.leasingApplicationScoringModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    _getFinancialIndicatorTemplate: function (field) {
        return function (dataItem) {
            var defRenderer = TS.UI.Renderers.grid._default,
                isPopup = false,
                baseCls = 'grid-cell',
                _getCellContent,
                _getCellClass,
                renderer,
                cellContent,
                cell,
                cls;



            if (field.renderer) {
                renderer = TS.UI.Renderers.grid[field.renderer] || defRenderer;
            }


            _getCellContent = (renderer && renderer.getCellContent) || defRenderer.getCellContent;
            cellContent = _getCellContent(field, dataItem, isPopup) || '';
            if (dataItem.FinancialIndicatorName.toLowerCase() === "year" || dataItem.FinancialIndicatorName.toLowerCase() === "month") {
                var val = dataItem[field.propertyName];
                var fmt = TS.Util.kendoNumericFormat(0, false);
                var str = kendo.toString(val, fmt);
                cellContent = '<span title=\"' + str + '\">' + str + '</span>';
            }

            _getCellClass = (renderer && renderer.getCellClass) || defRenderer.getCellClass;
            cls = baseCls + ' ' + (_getCellClass(field, dataItem) || '');
            cell = '<div class="' + cls + '">' + cellContent + '</div>';
            return cell;
        }
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var engineScoringList = me.getDomainProperty('ScoringEngineList'); 
        if (engineScoringList) {
            engineScoringList.on('selectionChanged', me._onEngineScoringChanged, me);
        }

        var gridCategory = me.getDomainProperty('gcScoringDocumentData_Property');
          
        if (gridCategory != null) {
            gridCategory.on('cellBeginEdit', me.onScoringCategoryCellEdit);
            gridCategory.on('cellValueChanged', me.onOptionOrUserValueChanged);

            gridCategory.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.tbody.children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        if (dataItem.Computed == true || dataItem.ReadOnlyCategory == true) {  
                            row.addClass("grey_readonly_scoring_category");
                        }
                    }
                }
            }
        }

        var financialInd = me.getDomainProperty('FinancialIndicatorsProperty');
        $.each(financialInd.Fields, function(idx, f) { 
            if (f.isDynamicColumn && f.type == null) {
                f.type = 'defaultType';
            }
        });

        financialInd.customiseOptions = function(options) {
            options.dataBound = function(e) {
                var rows = e.sender.tbody.children();
                for (var j = 0; j < rows.length; j++) {
                    var row = $(rows[j]);
                    var dataItem = e.sender.dataItem(row);
                    if (dataItem.FinancialIndicatorName != undefined && (dataItem.FinancialIndicatorName.toLowerCase() === "year" || dataItem.FinancialIndicatorName.toLowerCase() === "month")) {
                        row.addClass("scoring_bold_row");
                    }

                    if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold) {
                        row.addClass("scoring_financialIndicator_bold_row");
                    }

                    if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Bold_Red) {
                        row.addClass("scoring_financialIndicator_bold_red_row");
                    }

                    if (dataItem.StyleId == WL.Config.DictionaryFinancialIndicatorStyle.Italic) {
                        row.addClass("scoring_financialIndicator_italic_row");
                    }
                }
            },
                $.each(options.columns, function(idx, col) {
                    if (col.type === 'numeric') {
                        col.template = me._getFinancialIndicatorTemplate(col.fieldCfg.listField);
                        col.editor = me.createFinancialIndicatorEditor;
                    }
                });
        },
            financialInd.hideSelection = true;

        if (financialInd != null) {
            cat = financialInd.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'SelectIndicatorDimension';
            newCmd['Text'] = me.SelectIndicatorDimensionCommandText;
            newCmd['handler'] = '_selectIndicatorDimension';
            newCmd['IconCode'] = 'ellipsis-v';

            cat.push(newCmd);
        }

        var knockoutCriteriaList = me.getDomainProperty('dgKnockoutCriteriaCollection_Property');
        if (knockoutCriteriaList) {
            knockoutCriteriaList.on('cellBeginEdit', me.onKnockoutCriteriaBeginEdit, me);
        }

        externalSystemsList = me.getDomainProperty('ExternalSystemProperty');
        if (externalSystemsList) {
            externalSystemsList.on('cellBeginEdit', me.onExternalSystemBeginEdit, me);

            externalSystemsList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);
                        var dcell = row.children().eq(2);
                        var daLink = dcell.children().children();
                        daLink.removeAttr("target");
                        daLink.attr("href", "javascript:TS.UI.models.peek().ViewOrUploadAttachment('" + dataItem.ContentTypeId + "')");
                    }
                }
            }

        }

        var engineClassificationList = me.getDomainProperty('gcEngineScoringClassificationCollection_Property');
        if (engineClassificationList) {
            engineClassificationList.customiseOptions = function (options) {
                options.dataBound = function (e) {
                    var rows = e.sender.content.children("table").children("tbody").children();
                    for (var j = 0; j < rows.length; j++) {
                        var row = $(rows[j]);
                        var dataItem = e.sender.dataItem(row);

                        if (!dataItem.RowIsVisible) {
                            row.hide();
                            continue;
                        }
                    }
                }
            }
        }

    },

    onOptionOrUserValueChanged: function (e) {
        var me = this,
          rec = e.item,
          owner = me._getOwner(),
          categoryList = owner.getDomainProperty('gcScoringDocumentData_Property');

        if (e.fieldName == 'UserValue') {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: true,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            });
        }

        if (e.fieldName == 'ScoringDetailId') {
            owner.performServerCommand({
                cmd: 'UpdateScoringCategoryOptionOrValue',
                submitModel: true,
                extraData: {
                    IsUserValueModified: false,
                    IsNumericInputType: categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.NUMERIC,
                    ScoringCategoryId: categoryList.SelectedItem().ScoringId(),
                    ScoringCategoryDetailId: categoryList.SelectedItem().ScoringDetailId(),
                    UserValue: categoryList.SelectedItem().UserValue()
                },
                blockUI: true
            });
        }
    },

    onScoringCategoryCellEdit: function (e) {
        var me = this,
            owner = me._Domain,
            categoryList = owner.getDomainProperty('gcScoringDocumentData_Property');

        if (e.fieldName == 'ScoringDetailId' && (categoryList.SelectedItem().Computed() || categoryList.SelectedItem().ReadOnlyCategory()))
            e.preventDefault();

        if (e.fieldName == 'UserValue' && (categoryList.SelectedItem().InputTypeId() == WL.Config.ScoringCategoryInputType.SELECTION_LIST || categoryList.SelectedItem().ReadOnlyCategory() || categoryList.SelectedItem().Computed()))
            e.preventDefault();
    },

    onKnockoutCriteriaBeginEdit: function (e) {
        var me = this,
          rec = e.item;

        if (e.fieldName != 'Result')
            return;

        if (e.record.ManualYN() === false)
            e.preventDefault();
    },

    createFinancialIndicatorEditor: function(row, value, editor, rowHelper){
        var col = this,
            helper = rowHelper || col.helper,
            f = helper.field;

        //editor.jqxNumberInput({
        //    decimalDigits: f.decimalPrecision || 0,
        //    decimalSeparator: TS.cultures.current.decimalseparator,
        //    groupSeparator: f.useThousandSeparator ? TS.cultures.current.thousandsseparator : '',
        //    spinButtons: false,
        //    isNull: value === null
        //});
        editor.jqxNumberInput({
            decimalDigits: 0,
            decimalSeparator: TS.cultures.current.decimalseparator,
            groupSeparator: '',
            spinButtons: false,
            isNull: value === null
        });
    },


    _onEngineScoringChanged: function(e) {
        var me = this;

        if (me.insideChanging === true)
            return;

        onYes = function () {
            me.performServerCommand({ cmd: 'ScoringEngineChanged', submitModel: true, blockUI: true });
        };

        onNo = function() {
            me.insideChanging = true;

            me.Document.DocumentScoringAnalysis.EngineScoringId(e.prevRecord.Key);
            me.Document.DocumentScoringAnalysis.EngineScoringName(e.prevRecord.Value);

            var engineScoringList = me.getDomainProperty('ScoringEngineList');
            if (engineScoringList) {
                engineScoringList.SelectedItem(e.prevRecord);
            }

            me.insideChanging = false;
        };

        if (e.prevRecord != null && e.prevRecord.Key != null)
            TS.MsgBox.confirmYesNoCancel(null, me.ChangeScoringGridConfirmationMessage(), onYes, onNo, onNo);
        else
            onYes();
    },

    _selectIndicatorDimension: function () {
        var me = this;

        me.performServerCommand({
            cmd: 'SelectIndicatorDimension',
            submitModel: true,
            blockUI: false
        });
    },

    ViewOrUploadAttachment: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'ViewOrUploadAttachment',
            submitModel: true,
            extraData: {
                DocumentUID: e

            },
            blockUI: true
        });
    },

    onExternalSystemBeginEdit: function (e) {
        var me = this;

        if (e.fieldName !== 'Comment' && me.ReadOnly() === true) {
            e.preventDefault();
        }
    }
});

